<script>
export default {
    name: 'IconCalendar'
}
</script>
<template>
    <svg
        class="base-icon icon-calendar"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M27 8v4h10V8h6v4h13v44H8V12h13V8h6zm-4 34h-6v6h6v-6zm12 0h-6v6h6v-6zm12 0h-6v6h6v-6zM23 30h-6v6h6v-6zm12 0h-6v6h6v-6zm12 0h-6v6h6v-6zM21 17h-8v6h38v-6h-8v3h-6v-3H27v3h-6v-3z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
